var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRegularSchemes(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39.29,
    height: 32.706,
    viewBox: "0 0 39.29 32.706",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#4b4495;stroke:#b1b1f8;}.b{fill:#48d1cc;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.28 4.845)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M15295.522,5379.654a1.911,1.911,0,0,0,1.362-.535l6.987-6.742a1.913,1.913,0,0,0,.047-2.706l-6.747-6.978a1.919,1.919,0,0,0-2.644-.107c-3.113,3.007-7.048,6.8-7.048,6.8s-.781,1.945-.047,2.706l6.746,6.978A1.91,1.91,0,0,0,15295.522,5379.654Z",
    transform: "translate(-15277.925 -5359.381)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2.689 8.794) rotate(-30)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M28.454,31.336l-7.505,1.1a3.922,3.922,0,0,1-2.777-.759l-4.388-3.275-.008-.006a.954.954,0,0,1-.033-1.517.9.9,0,0,1,.752-.17l3.82,1.675a1.719,1.719,0,0,0,1.445.793,1.75,1.75,0,0,0,.377-.044l3.8-.858a.443.443,0,0,0-.195-.864l-3.8.861a.864.864,0,0,1-.182.021.842.842,0,0,1-.773-.521A.885.885,0,0,1,19,27.051a.839.839,0,0,1,.526-.454l5.356-1.574A2.172,2.172,0,0,1,26.018,25l2.436,1.032Z",
    transform: "translate(-2.027 -3.89)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M31.109,30.712a.442.442,0,1,0,.442.442.442.442,0,0,0-.442-.442Zm.431,2.253H30.006a.675.675,0,0,1-.667-.684V25.448A.675.675,0,0,1,30,24.763h1.534a.442.442,0,0,0,.442-.442v9.087a.442.442,0,0,0-.442-.442Z",
    transform: "translate(-2.027 -3.89)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1.279 3.63) rotate(-30)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M13.383,26.063l7.5-1.1a3.922,3.922,0,0,1,2.777.759l4.388,3.275.008.006a.954.954,0,0,1,.033,1.517.9.9,0,0,1-.751.17l-3.82-1.675a1.719,1.719,0,0,0-1.445-.793,1.75,1.75,0,0,0-.377.044l-3.8.858a.443.443,0,0,0,.195.864l3.8-.861a.864.864,0,0,1,.182-.021.842.842,0,0,1,.773.521.885.885,0,0,1-.016.723.839.839,0,0,1-.526.454l-5.356,1.574a2.172,2.172,0,0,1-1.133.024l-2.436-1.032Z",
    transform: "translate(-9.859 -23.986)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M30.209,27.017a.442.442,0,1,0-.442-.442.442.442,0,0,0,.442.442Zm-.431-2.253h1.534a.675.675,0,0,1,.667.684v6.834a.675.675,0,0,1-.664.684H29.782a.442.442,0,0,0-.442.442V24.321a.442.442,0,0,0,.442.442Z",
    transform: "translate(-29.34 -24.316)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M4.71,3.977a1.374,1.374,0,0,0-.3,2.731,1.42,1.42,0,0,0,.153.009A1.374,1.374,0,0,0,4.71,3.977Zm.3,1.415a.448.448,0,0,1-.167.3h0a.451.451,0,1,1-.283-.8h.05a.452.452,0,0,1,.4.5Zm.471-4.018A.461.461,0,0,0,4.831,1.3L.558,4.724a.461.461,0,1,0,.577.72L5.408,2.022a.461.461,0,0,0,.071-.646ZM1.219,2.726a1.438,1.438,0,0,0,.154.008,1.367,1.367,0,1,0-.154-.008Zm-.3-1.415a.451.451,0,1,1,.731.4h0a.451.451,0,0,1-.731-.4Z",
    transform: "translate(14.062 8.966) rotate(-14)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegularSchemes);
export default __webpack_public_path__ + "static/media/regular_schemes.afc0438f8a6b8fb5caa05a6190a01ec8.svg";
export { ForwardRef as ReactComponent };